import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", {
  class: "close",
  title: "Close"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "minimize",
  title: "Minimize"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "zoom",
  title: "Zoom"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LayoutRow = _resolveComponent("LayoutRow")!

  return (_openBlock(), _createBlock(_component_LayoutRow, { class: "window-buttons mac" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3
    ]),
    _: 1
  }))
}